/* Formatage de date FR — extrait de AccountSettingsPage.tsx (réutilisable). */
export function formatDate(iso: string | null): string {
  if (!iso) return '-';
  return new Date(iso).toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
